import React, { useEffect, useState } from "react";
import { Button, Checkbox } from "antd";
import crosswhite from "../../../../public/assets/icons/cross-white.svg";
import { useMutation, useQuery } from "@tanstack/react-query";

import {
  getFarmersFields,
  getPaymentInfos,
  updateWeatherStation,
} from "../../../../services/api";

import {
  Service,
  WeatherStationStates,
  calculatePremonitionRobot,
  calculateTotalCost,
  threeDigitsSeparator,
} from "@helpers/ui_helper";

import FormWithRows from "./components/Test";
import { CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

function StationPayment({ setWeatherStationState, weatherStationId }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [rowState, setRowState] = useState(false);
  //اطلاعات لحظه‌ای هواشناسی و پیش بینی روزانه
  const weatherStationInformationAndForecastId = 1;
  const farmersFieldsQuery = useQuery(["farmersFields"], getFarmersFields);
  // let count = 0
  const getPaymentInfosMutation = useMutation(getPaymentInfos, {
    onSuccess: (data) => {
      window.open(data, "_self");
    },
  });

  const updateWeatherStationMutation = useMutation(updateWeatherStation, {
    onSuccess: (id) => {
      const state = {
        paymentSelector: false,
        paymentType: "WALLET",
        from: location.pathname + location.search,
      };
      navigate(`/payment/${id}`, { state });
    },
  });

  const [weatherStationServices, setWeatherStationServices] = useState([]);
  const [smsServiceCost, setSmsServiceCost] = useState();
  const [weatherStationBaseCost, setWeatherStationBaseCost] = useState();
  const [optionsObject, setOptionsObject] = useState({
    servicesIds: [weatherStationInformationAndForecastId, 2],
    alertPhoneNumbers: [],
  });

  useEffect(() => {
    if (farmersFieldsQuery?.data) {
      setWeatherStationServices(
        farmersFieldsQuery?.data?.farmersFields["WEATHER_STATION_SERVICES"]
      );
      // setOptionsObject((prev)=> ( {...prev,servicesIds: [weatherStationInformationAndForecastId,weatherStationServices[1]?.id]}))
      setSmsServiceCost(
        farmersFieldsQuery?.data?.farmersFields[
          "WEATHER_STATION_ALERT_PHONE_NUMBER_COST"
        ]
      );
      setWeatherStationBaseCost(
        farmersFieldsQuery?.data?.farmersFields["WEATHER_STATION_BASE_COST"]
      );
    }
  }, [farmersFieldsQuery?.data]);

  const handleCheckbox = (e) => {
    if (e.target.checked) {
      setOptionsObject({
        ...optionsObject,
        servicesIds: [...optionsObject.servicesIds, e.target.name],
      });
    } else {
      if (e.target.name === "premonitionRobot") {
        if (!rowState) {
          setRowState(true);
        } else {
          setRowState(false);
        }
        setOptionsObject({
          ...optionsObject,
          servicesIds: optionsObject.servicesIds.filter(
            (servicesId) =>
              servicesId !== e.target.name &&
              servicesId !== 3 &&
              servicesId !== 4
          ),
        });
      } else {
        setOptionsObject({
          ...optionsObject,
          servicesIds: optionsObject.servicesIds.filter(
            (servicesId) => servicesId !== e.target.name
          ),
        });
      }
    }
  };

  // const addPhoneNumber = () => {

  //   if (count !== 5) {
  //     setOptionsObject(prev => ({
  //       ...prev,
  //       alertPhoneNumbers: [...prev.alertPhoneNumbers, {
  //         fullName: '',
  //         position: '',
  //         phoneNumber: ''
  //       }]
  //     }))
  //   }
  // }

  const updateStation = () => {
    updateWeatherStationMutation.mutate({
      data: {
        servicesIds: optionsObject?.servicesIds.filter(
          (sId) => sId !== "premonitionRobot"
        ),
        alertPhoneNumbers: optionsObject?.alertPhoneNumbers.map((apn) => apn),
      },
      weatherStationId: weatherStationId,
    });
  };
  return (
    <div className="Payment box-shadow agrobg font-body max-w-[1000px] w-[50vw] max-lg:w-full p-4 max-lg:p-2 rounded-[1rem] border border-slate-100 justify-between items-center flex">
      <div className="Right w-full px-8 py-3 max-lg:p-1 flex-col justify-start items-center gap-3 flex">
        <p className="Onvan text-agrotext te text-[20px] max-lg:text-xs font-bold w-full">
          لطفا امکانات مدنظر خود را جهت فعال‌سازی ایستگاه انتخاب نمایید
        </p>

        <div className="Lahzeiei flex self-stretch justify-between items-center ">
          <p className=" text-right text-agrotext text-lg max-lg:text-xs font-medium ">
            قیمت پایه خدمات ایستگاه
          </p>

          <p className="tracking-wider text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
            {`${threeDigitsSeparator(weatherStationBaseCost / 10)} تومان`}
          </p>
        </div>

        <div className="Lahzeiei flex self-stretch justify-between items-center ">
          <p className=" text-right text-agrotext text-lg max-lg:text-xs font-medium ">
            اطلاعات لحظه‌ای هواشناسی و پیش‌بینی تا 16 روز آینده
          </p>

          <p className="tracking-wider text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
            {`${threeDigitsSeparator(
              weatherStationServices[0]?.cost / 10
            )} تومان`}
          </p>
        </div>

        <div className="w-full text-right text-neutral-600 text-[12px]">
          <InfoCircleOutlined /> این اطلاعات از زمان فعالسازی تا یکسال برای شما
          فعال خواهد بود.
        </div>

        <hr className="w-full" />

        <div className="Frame5 self-stretch justify-between items-center flex">
          <Checkbox
            className="check1 font-body w-fit text-right text-[#404848]  text-lg max-lg:text-xs font-medium"
            name={weatherStationServices[1]?.id}
            onChange={handleCheckbox}
            checked={optionsObject.servicesIds.includes(
              weatherStationServices[1]?.id
            )}
          >
            {weatherStationServices[1]?.name}
          </Checkbox>

          <div className=" text-right text-zinc-500 text-base max-lg:text-sm font-medium ">
            {`${threeDigitsSeparator(
              weatherStationServices[1]?.cost / 10
            )} تومان`}
          </div>
        </div>

        <div className="w-full text-right text-neutral-600 text-[12px]">
          <InfoCircleOutlined /> اطلاعات اقلیمی به صورت فایل اکسل قابل دانلود
          بوده و برای همیشه در دسترس شما خواهد بود.
        </div>

        <hr className="w-full" />

        <div className="Frame6 self-stretch justify-between items-center flex">
          <Checkbox
            className="check2 font-body w-fit text-right text-[#404848] text-lg max-lg:text-xs font-medium"
            name="premonitionRobot"
            onChange={handleCheckbox}
            checked={optionsObject.servicesIds.includes("premonitionRobot")}
          >
            ربات پیش آگاهی هواشناسی
          </Checkbox>

          <div className="flex flex-row text-right gap-1 text-zinc-500 text-base font-medium ">
            {calculatePremonitionRobot(
              weatherStationServices,
              optionsObject,
              smsServiceCost,
              weatherStationBaseCost
            )}
            {<p>تومان </p>}
          </div>
        </div>
        <div className="w-full text-right text-neutral-600 text-[12px]">
          <InfoCircleOutlined /> این ربات از زمان فعالسازی تا پایان اعتبار
          ایستگاه، برای شما فعال خواهد بود.
        </div>

        <div
          className={`${
            optionsObject.servicesIds.includes("premonitionRobot")
              ? "flex flex-col"
              : "hidden"
          }`}
        >
          <div className=" p-2 border-t border-slate-200 justify-end items-start gap-2 flex flex-wrap max-lg:flex-col">
            {!optionsObject?.servicesIds?.includes(
              weatherStationServices[2]?.id
            ) &&
            !optionsObject?.servicesIds?.includes(
              weatherStationServices[3]?.id
            ) ? (
              <div className="w-full text-center text-red-400 animate-pulse text-[14px]">
                انتخاب حداقل یکی از گزینه های زیر ضروری است.
              </div>
            ) : null}

            <div className="right lg:w-[296px] max-lg:w-full flex-col justify-start items-end gap-3 flex">
              <div className="Frame7 self-stretch h-7 justify-start items-center gap-1 flex">
                <Checkbox
                  className=" text-right text-agrotext text-lg max-lg:text-sm font-medium"
                  name={weatherStationServices[2]?.id}
                  onChange={handleCheckbox}
                  checked={optionsObject?.servicesIds?.includes(
                    weatherStationServices[2]?.id
                  )}
                >
                  {weatherStationServices[2]?.name}
                </Checkbox>
              </div>
              <div className=" text-right text-neutral-600 text-[12px]">
                <InfoCircleOutlined /> در زمان‌های خطر، هشدارهایی جهت پیشگیری از
                خسارت به شماره موبایل‌های انتخابی شما پیامک خواهد شد.
              </div>
            </div>

            <div className="left lg:w-[296px] max-lg:w-full flex-col justify-start items-end gap-3 flex">
              <div className=" self-stretch h-7 justify-start items-center gap-1 flex">
                <Checkbox
                  className="  text-right text-agrotext text-lg max-lg:text-sm font-medium"
                  name={weatherStationServices[3]?.id}
                  onChange={handleCheckbox}
                  checked={optionsObject?.servicesIds?.includes(
                    weatherStationServices[3]?.id
                  )}
                >
                  {weatherStationServices[3]?.name}
                </Checkbox>
              </div>
              <div className="text-right text-neutral-600 text-[12px]">
                <InfoCircleOutlined /> به صورت روزانه اطلاعات دما، رطوبت، باد و
                احتمال بارش به شماره موبایل‌های انتخابی شما پیامک خواهد شد.
              </div>
            </div>
          </div>

          <div className="Frame1137 px-4 py-2 border-t border-slate-200 flex-col justify-start items-start gap-3 flex">
            <p className="SMS text-center text-neutral-600 text-base max-lg:text-[11px] font-semibold ">
              لیست شماره موبایل‌ها جهت ارسال پیامک‌های ربات پیش‌آگاهی
            </p>
            <FormWithRows
              rowState={rowState}
              setRowState={setRowState}
              optionsObject={optionsObject}
              setOptionsObject={setOptionsObject}
            />
          </div>
        </div>

        <div className="flex flex-row gap-2 items-center justify-center text-center text-agrotext text-2xl max-lg:text-xl font-medium ">
          <p>هزینه خدمات: </p>
          {calculateTotalCost(
            weatherStationServices,
            optionsObject,
            smsServiceCost,
            weatherStationBaseCost
          )}
          <p>تومان</p>
        </div>

        <div className="buttons justify-center items-center gap-2.5 flex max-lg:flex-row-reverse">
          <Button
            loading={
              updateWeatherStationMutation.isLoading ||
              getPaymentInfosMutation.isLoading
            }
            className="Cancel px-4 hover:brightness-110 h-[44px] button-red border !border-slate-200 justify-center items-center gap-1 flex"
            onClick={() =>
              setWeatherStationState({
                service: Service.Weather,
                state: WeatherStationStates.AddStationIntro,
                stationObject: null,
              })
            }
          >
            <img
              src={crosswhite}
              alt="cancel-icon"
              className="w-[20px] h-[20px]"
            />

            <p className=" text-center w-20 !text-white text-2xl max-lg:text-base font-medium font-body">
              بازگشت
            </p>
          </Button>

          <Button
            disabled={
              (!optionsObject?.alertPhoneNumbers?.length &&
                optionsObject?.servicesIds?.includes("premonitionRobot") &&
                (!optionsObject?.servicesIds?.includes(
                  () => weatherStationServices[2]?.id
                ) ||
                  !optionsObject?.servicesIds?.includes(
                    () => weatherStationServices[3]?.id
                  ))) ||
              (optionsObject?.alertPhoneNumbers?.length !== 0 &&
                optionsObject?.servicesIds?.includes("premonitionRobot") &&
                !optionsObject?.servicesIds?.includes(
                  weatherStationServices[2]?.id
                ) &&
                !optionsObject?.servicesIds?.includes(
                  weatherStationServices[3]?.id
                ))
            }
            className="Submitpayment px-6 text-white text-2xl h-[44px] hover:brightness-110 !border-slate-200 button-green justify-center items-center gap-1 max-lg:text-base flex"
            onClick={updateStation}
            loading={
              updateWeatherStationMutation.isLoading ||
              getPaymentInfosMutation.isLoading
            }
            icon={<CheckOutlined className="text-white text-2xl" />}
          >
            ثبت سفارش
          </Button>
        </div>
      </div>
    </div>
  );
}

export default StationPayment;
